import { render } from "./CaptionGreen.vue?vue&type=template&id=27a547c8&scoped=true"
import script from "./CaptionGreen.vue?vue&type=script&lang=js"
export * from "./CaptionGreen.vue?vue&type=script&lang=js"

import "./CaptionGreen.vue?vue&type=style&index=0&id=27a547c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a547c8"]])

export default __exports__